<template lang="pug">
#app
  router-view
  ModalContent
</template>
<script>
import Vue from 'vue'
import VueRouter from 'vue-router'
import grapesjs from 'grapesjs'

import ModalContent from '@/components/shared/modal.vue'
require('grapesjs-preset-newsletter')

Vue.use(VueRouter)
Vue.use(grapesjs)

export default {
  name: 'app',
  meta: {
    titleTemplate: '%s - Inom.ph Admin',
  },
  components: {
    ModalContent
  }
}
</script>

<style>
@import url('./assets/css/app.css');
 .v-text-field input{
  border-bottom: none !important;
  margin-bottom: 0 !important;
}
#sendemailTransaction input, #sendemailTransaction .selected-email {
    color: black;
    font-weight: 500 !important;
}
#sendemailTransaction input.subject{
  background: #ffffff;
    padding: 7px;
    border-radius: 9px;
        height: 25px;
    width: 98%;
}
#sendemailTransaction .v-datatable__actions__select{
  display: none;
}
#sendemailTransaction{
      margin: 20px 10px 20px 10px;
}
.selected-email-panel {
    width: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    background: #ffffff;
    padding: 7px;
    border-radius: 9px;
    max-height: 168px;
    min-height: 41px;
    overflow: auto;
}
.gjs-mdl-dialog {
    max-height: 95vh;
    min-height: auto;
    overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue